<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="7.582" height="14.926" viewBox="0 0 7.582 14.926">
        <path
            id="angle-up"
            d="M13.683,0A1.338,1.338,0,0,0,12.8.32L7.464,4.968,2.123.317a1.377,1.377,0,0,0-1.759,0,.987.987,0,0,0,0,1.532L6.583,7.265a1.377,1.377,0,0,0,1.759,0l6.219-5.416a.987.987,0,0,0,0-1.532A1.339,1.339,0,0,0,13.683,0Z"
            transform="translate(0 14.926) rotate(-90)"
        />
    </svg>
</template>
